import Button, { ButtonKind, ButtonSize } from '@/components/UI/Buttons/Button/Button'
import styles from './UnpairVPadModal.module.css'
import { useTranslations } from 'next-intl'
import { useModalStore } from '@/stores/useModalStore'
import GamepadsModal from '../GamepadsModal/GamepadsModal'
import { ModalTypes } from '@/interfaces/api/generic/api_modals_types'
import { PadManager } from '@/services/VirtualPad/PadManager'
import { useState } from 'react'
import VPadPairingModal from '../VPadPairingModal/VPadPairingModal'
import { usePadsStore } from '@/stores/usePadsStore'

interface UnpairVPadModalProps {
  connectionId: string
  deviceName: string
}

export default function UnpairVPadModal ({ connectionId, deviceName }: UnpairVPadModalProps) {
  const t = useTranslations('Modals.VPadUnpairing')
  const openModal = useModalStore(state => state.openModal)

  const [isLeaving, setIsLeaving] = useState(false)

  /**
   * Handle the cancel action by closing the modal
   */
  function handleCancel () {
    openModal({
      type: ModalTypes.LATERAL,
      content: <GamepadsModal />
    })
  }

  /**
   * Handle the confirm action by unpairing the device
   */
  function handleConfirm () {
    setIsLeaving(true)

    try {
      PadManager.getInstance().leaveVPad(connectionId)
    } finally {
      const { physicalPads, vpads } = usePadsStore.getState()
      const hasGamepads = Object.keys(physicalPads).length > 0 || Object.keys(vpads).length > 0

      openModal({
        type: ModalTypes.LATERAL,
        content: hasGamepads
          ? <GamepadsModal />
          : <VPadPairingModal />
      })
    }
  }

  return (
    <div className={styles.unpairVPadModal}>
      <p className={`title3 ${styles.content}`}>{t('content', {deviceName: deviceName})}</p>

      <div className={styles.buttonsWrapper}>
        <Button
          kind={ButtonKind.PRIMARY}
          size={ButtonSize.MEDIUM}
          onClick={handleCancel}
        >
          {t('buttons.cancel')}
        </Button>

        <Button
          kind={ButtonKind.PRIMARY}
          size={ButtonSize.MEDIUM}
          disabled={isLeaving}
          onClick={handleConfirm}
        >
          {t('buttons.confirm')}
        </Button>
      </div>
    </div>
  )
}